<template>
	<transition name="fade">
		<div class="library">
			<div class="ss-breadcrumb">
				<div class="container-hts">
					<ul class="margin-0 p-0">
						<li>
							<router-link to="/thu-vien">Thư viện</router-link>
						</li>
					</ul>
				</div>
			</div>
			<div class="ss-banner ss-banner--shadow-img ss-banner--ebook ss-banner--not-bg">
				<div class="container-hts">
					<FilterMobile v-if="isMobile && dataConfigFilter && dataConfigFilter.length"
						:classes="dataConfigFilter" :selectClass="classActive"
						:types="[{ id: tabPageLinks, name: 'Học liệu điện tử' }, { id: tabLesson, name: 'Bài giảng điện tử' }, { id: tabActiveLearning, name: 'Chương trình học chủ động' }]"
						@search="handleFilterData" @searchClass="filterDataClassInMobile" @searchTab="filterLibByTab" />
					<div v-else class="ss-banner__wrap display-flex-end justify-content-between">
						<div class="ss-banner__classes" v-if="dataConfigFilter && dataConfigFilter.length">
							<span class="ss-banner__classes__name">Lớp</span>
							<ul class="ss-banner__classes__list p-0 margin-0">
								<li v-for="(item, index) of dataConfigFilter" :key="`class_${index}`">
									<a href="javascript:;" class="height-100"
										:class="{ 'active': item.classId == classActive }"
										@click="filterDataLibsByClass(item, index)">
										<img v-if="item.classId == classActive" src="@/assets/images/bg-number.png"
											:alt="item.classNo" />
										<span :class="{ 'mn': item.name == 'Mầm non' }" class="font-sanpro-bold">{{
						formatName(item.name) }}</span>
									</a>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
			<div class="ss-data">
				<div class="container-hts">
					<div class="library__wrap display-flex justify-content-between">
						<!-- <Sidebar :dataSubject="dataSubject" /> -->
						<div class="library__data">
							<div v-if="!isMobile"
								class="library__data__head tabs-tooltip display-flex-center justify-content-between">
								<b-tabs class="border-0">
									<b-tab title="Học liệu điện tử (Phiên bản 1.0)"
										:active="!routerQuery.tab || (routerQuery.tab && routerQuery.tab.toString() === tabPageLinks.toString())"
										@click="filterLibByTab(tabPageLinks)"></b-tab>
									<b-tab title="Bài giảng điện tử (Phiên bản 1.0)"
										:active="routerQuery.tab && routerQuery.tab.toString() === tabLesson.toString()"
										@click="filterLibByTab(tabLesson)"></b-tab>
									<b-tab title="Chương trình học chủ động"
										:active="routerQuery.tab && routerQuery.tab.toString() === tabActiveLearning.toString()"
										@click="filterLibByTab(tabActiveLearning)"></b-tab>
									<!-- <b-tab title="Thiết bị dạy học"></b-tab> -->
								</b-tabs>
								<div class="library__data__head__collapse">
									<a @click="toggleCollapseKeyword" href="javascript:;"
										class="btn-collapse btn border-rd-20 font-size-15 primary-color"
										:class="{ 'btn-main': openCollapseFilterKey, 'btn-main-light': !openCollapseFilterKey }">
										<i class="icon-search margin-0"
											:class="{ 'color-light': openCollapseFilterKey, 'primary-color': !openCollapseFilterKey }"></i>
									</a>
									<a href="javascript:;" @click="toggleCollapseGroup"
										class="btn-collapse btn border-rd-20 font-size-15 filter-btn"
										:class="{ 'btn-main': openCollapseFilterGroup, 'btn-main-light': !openCollapseFilterGroup }">
										Bộ lọc <i class="icon-arrow-down font-size-12"
											:class="{ 'color-light': openCollapseFilterGroup, 'primary-color': !openCollapseFilterGroup }"></i>
									</a>
								</div>
								<!-- <a v-b-toggle.collapse_filter class="btn-collapse btn btn-main-light border-rd-20 font-size-15 primary-color">Bộ lọc <i class="icon-arrow-down font-size-12"></i></a> -->
							</div>
							<b-collapse id="collapse_filter_keyword" class="mt-2" :visible="openCollapseFilterKey">
								<div class="library__data__filter display-flex-center justify-content-between">
									<div class="library__data__filter__keyword">
										<div class="input-custom-icon">
											<!-- v-model.lazy="keyword"
												v-debounce="300" -->
											<input type="text" class="color_bg_gray_light border-0 border-rd-20"
												placeholder="Tìm kiếm" @input="handleSearchByKeyword" />
											<i class="icon-search primary-color"></i>
										</div>
									</div>
									<!-- <div class="library__data__filter__sort"> -->
									<!-- <a href="javascript:;" class="secondary-color-txt" @click="handleFilterSort">Sắp xếp theo tên <i class="secondary-color-txt font-size-14" :class="{'icon-arrow-up': paramSearchLessons.direction === 'desc', 'icon-arrow-down': paramSearchLessons.direction === 'asc'}"></i></a> -->
									<!-- <select name="sort" class="border-0 secondary-color-txt">
										<option value="name">Sắp xếp theo tên</option>
										</select> -->
									<!-- </div> -->
								</div>
							</b-collapse>
							<b-collapse id="collapse_filter" class="mt-2" :visible="openCollapseFilterGroup">
								<FilterCollapse @search="handleFilterData" />
							</b-collapse>
							<div class="library__book">
								<div v-if="keyFilterBox && keyFilterBox.includes(paramSearchLessons.filterType)"
									class="electronic-lecture__head filter-result__head display-flex-center justify-content-between">
									<h2 class="primary-color-txt font-size-24 font-sanpro-semibold">Học liệu theo mục
										lục</h2>
								</div>
								<ResultBookFilter
									v-if="!$route.query.tab || parseInt($route.query.tab) === tabPageLinks"
									:typeLoading="tabPageLinks" :dataSource="resultBookPageLinkFilter" />
								<ResultBookFilter v-if="$route.query.tab && parseInt($route.query.tab) === tabLesson"
									:typeLoading="tabLesson" :dataSource="resultBookLessonFilter" />
								<ResultBookFilter
									v-if="$route.query.tab && parseInt($route.query.tab) === tabActiveLearning"
									:typeLoading="tabActiveLearning" :dataSource="resultBookActiveLearning" />
								<p v-if="keyFilterBox && (
						(keyFilterBox.includes(tabPageLinks) && paramSearchLessons.filterType === tabPageLinks && resultBookPageLinkFilter.length === 0) ||
						(paramSearchLessons.filterType === tabLesson && keyFilterBox.includes(tabLesson) && resultBookLessonFilter.length === 0) ||
						(paramSearchLessons.filterType === tabActiveLearning && keyFilterBox.includes(tabActiveLearning) && resultBookActiveLearning.length === 0))"
									class="font-size-22 secondary-color-txt text-center">Không tìm thấy dữ liệu phù hợp
								</p>
							</div>
							<div class="library__list">
								<SectionListItem v-if="librariesData && !isEmptyAllData" :dataSource="librariesData"
									:tab="tabActive" />
								<p v-else-if="isEmptyAllData && ((paramSearchLessons.filterType === tabPageLinks && resultBookPageLinkFilter.length === 0) || (paramSearchLessons.filterType === tabLesson && resultBookLessonFilter.length === 0) || (paramSearchLessons.filterType === tabLesson && resultBookActiveLearning.length === 0)) "
									class="font-size-22 secondary-color-txt text-center" style="margin-top: 50px;">
									Dữ liệu đang cập nhật!
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
import { STORE_KEY, TAB_MEDIA_PAGE_LINK, TAB_LESSON, TAB_ACTIVE_LEARNING } from "../_store/constants";
import { mapState, mapActions } from "vuex";
import { getDataSubportFilter, getLessonsPlan, getMediaListInLibs, getLibrariesData, getListActiveLearningHome } from './../_api/'
import vueCustomScrollbar from 'vue-custom-scrollbar'
// import debounce from '@/directives/debounce'
import { debounce } from 'debounce'

export default {
	name: "ViewLibrary",
	components: {
		vueCustomScrollbar,
		SectionListItem: () => import('./../_components/list/SectionListItem.vue'),
		Sidebar: () => import('./../_components/list/Sidebar.vue'),
		FilterCollapse: () => import('./../_components/list/FilterCollapse.vue'),
		ResultBookFilter: () => import('./../_components/list/ResultBookFilter.vue'),
		FilterMobile: () => import('./../_components/list/FilterMobile.vue')
	},
	// directives: { debounce },
	data() {
		return {
			tabActive: 0,
			tabPageLinks: TAB_MEDIA_PAGE_LINK,
			tabLesson: TAB_LESSON,
			tabActiveLearning: TAB_ACTIVE_LEARNING,
			dataConfigFilter: [],
			dataSubject: [],
			classActive: 1,
			librariesData: [],
			dataLibFetch: [],
			isCreated: true, // for replace router
			isEmptyAllData: false,
			keyFilterBox: [],
			openCollapseFilterGroup: false,
			openCollapseFilterKey: false,
			keyword: '',
			windowWidth: 0
		};
	},
	computed: {
		...mapState(STORE_KEY, ['paramSearchLessons', 'resultBookPageLinkFilter', 'resultBookLessonFilter', 'resultBookActiveLearning']),
		routerQuery() {
			return this.$route.query;
		},
		isMobile() {
			return this.windowWidth < 991 ? true : false;
		}
	},
	watch: {
		'paramSearchLessons': 'getLibsData',
		keyword: 'handleFilterKeyword'
	},
	mounted() {
		// this.acGetBookActiveLearning([])
		this.$nextTick(function () {
			window.addEventListener('resize', this.getWindowWidth);
			//Init
			this.getWindowWidth()

			// if(this.$route.query.lop){
			// 	console.log('123123:'+this.$route.query.lop)
			// 	this.setParamSearchLesson({...this.paramSearchLessons,classId:this.$route.query.lop, sort: '' , direction: '', pageIndex: 1,pageSize:24 });
			// }
			// else{
			// 	this.setParamSearchLesson({...this.paramSearchLessons, sort: '' , direction: '', pageIndex: 1,pageSize:24 });
			// }
		})


		// Reset book result searched
		this.initPage();
		this.acResetBookFilterLib()
	},
	beforeDestroy() {
		this.setParamSearchLesson({ ...this.paramSearchLessons, pageIndex: 1 });
	},
	methods: {
		...mapActions("common", ["setLoading", 'acToggleModalActiveBook']),
		...mapActions(STORE_KEY, ["setParamSearchLesson", 'acResetBookFilterLib', 'acGetBookActiveLearning']),

		initPage() {
			let query = this.routerQuery;
			let classActived = query.lop && query.lop !== 0 ? parseInt(query.lop) : 1
			this.tabActive = query.tab ? query.tab : TAB_MEDIA_PAGE_LINK;
			console.log(classActived)
			this.getClassSubjectForFilter(classActived);

			if (query.lop && query.lop !== 0) {
				this.classActive = query.lop;
			}
		},
		formatName(name) {
			if (name == 'Mầm non') {
				return name
			}
			return name.substring(4)
		},
		getWindowWidth(event) {
			this.windowWidth = window.innerWidth
		},

		getClassSubjectForFilter(classId = 1) {
			let self = this;
			// self.setLoading(true);
			getDataSubportFilter(classId).then(res => {
				if (res && res.data && !res.errors) {
					self.dataConfigFilter = res.data;
					let indexClassActive = res.data.findIndex(cl => cl.classId === parseInt(classId));
					if (indexClassActive > -1) {
						self.dataSubject = res.data[indexClassActive].subjects;
						self.classActive = classId;
						if ((!self.routerQuery.lop || self.routerQuery.lop === 0) && self.isCreated) {
							self.setParamSearchLesson({ ...self.paramSearchLessons, classId, bookLessonPlanTypeId: 0, documentTypeId: 0, bookIndexId: 0, subjectId: 0, className: res.data[indexClassActive].name });
							self.isCreated = false;
						} else if (self.isCreated && (!self.routerQuery.mon || parseInt(self.routerQuery.mon) === 0) && (!self.routerQuery.nhom || parseInt(self.routerQuery.nhom) === 0)) {
							self.setParamSearchLesson({ ...self.paramSearchLessons, className: res.data[indexClassActive].name, classId: parseInt(self.routerQuery.lop), documentTypeId: 0 });
						}
					}
				}
			})
			// .finally(() => self.setLoading(false));
		},

		filterDataClassInMobile(data) {
			this.filterDataLibsByClass(data.classItem, data.index)
		},

		filterDataLibsByClass(classItem, index) {
			this.classActive = classItem.classId;
			this.$router.replace({ query: { lop: classItem.classId, tab: this.tabActive } });

			this.setParamSearchLesson({ ...this.paramSearchLessons, classId: classItem.classId, className: classItem.name, subjectId: 0 });
		},

		getLibsData() {
			let self = this
			if (!self.paramSearchLessons.classId) {
				return
			}
			// self.setLoading(true)

			switch (parseInt(self.tabActive)) {
				case TAB_MEDIA_PAGE_LINK:
					self.getLibsMedias()
					break
				case TAB_LESSON:
					self.getLibsLesson()
					break
				case TAB_ACTIVE_LEARNING:
					self.getLibsAvtLearning()
					break
			}
		},

		getLibsLesson() {
			let self = this;

			getLessonsPlan(self.paramSearchLessons).then(res => {
				if (res && res.data && res.data.list && !res.errors) {
					self.librariesData = res.data.list;
					// console.log('typeof 1', typeof self.librariesData );

					self.checkEmptyAllData(res.data.list);
				}
			}).finally(() => self.setLoading(false));
		},

		getLibsMedias() {
			let self = this;
			getMediaListInLibs(self.paramSearchLessons).then(res => {
				if (res && res.data && res.data.list && !res.errors) {
					self.librariesData = res.data.list;
					// console.log('typeof 2', typeof self.librariesData );
					self.checkEmptyAllData(res.data.list);
				}
			}).finally(() => self.setLoading(false));
		},

		getLibsAvtLearning() {
			let self = this;
			// console.log('self.paramSearchLessons', self.paramSearchLessons);
			getListActiveLearningHome(self.paramSearchLessons).then(res => {
				if (res && res.data && res.data.list && !res.errors) {
					self.librariesData = res.data.list;
					// console.log('typeof 123', res.data.list);

					self.checkEmptyAllData(res.data.list);
				}
			}).finally(() => self.setLoading(false));
		},

		checkEmptyAllData(data) {
			// console.log('vaoo day khong', data);
			let self = this;
			self.isEmptyAllData = false;
			let countData = data.length;
			let numDataEmpty = 0;
			data.map(group => {
				if (!group.count || parseInt(group.count) === 0) {
					numDataEmpty += 1;
				}
				if (numDataEmpty === countData) {

					// if(self.tabAtvLearning === 3){
					// 	self.isEmptyAllData = false;
					// } else{ 
					self.isEmptyAllData = true;
					// }
				}
			})
		},

		filterLibByTab(tab) {
			// console.log('tabbbb', tab);
			// console.log('routerQuery.tab', this.routerQuery.tab);
			let self = this;
			let tabCurr = this.$route.query.tab ? parseInt(this.$route.query.tab) : 1
			if (parseInt(tab) !== tabCurr) {
				this.tabActive = parseInt(tab);
				this.librariesData = []
				this.$router.replace({ query: { ...this.routerQuery, tab } });
				switch (tab) {
					case TAB_LESSON:
						this.setParamSearchLesson({ ...this.paramSearchLessons, filterType: tab, bookGroupId: 0, subjectId: 0 });
						break;
					case TAB_MEDIA_PAGE_LINK:
						this.setParamSearchLesson({ ...this.paramSearchLessons, filterType: tab, bookGroupId: 0, subjectId: 0 });
						break;
					case TAB_ACTIVE_LEARNING:
						// console.log('vao tab active learing');
						this.setParamSearchLesson({ ...this.paramSearchLessons, filterType: tab, bookGroupId: 0, subjectId: 0 });
						break;
				}
			}
		},

		handleFilterData(val) {
			!this.keyFilterBox.includes(val) && this.keyFilterBox.push(val)
		},

		toggleCollapseGroup() {
			this.openCollapseFilterGroup = !this.openCollapseFilterGroup
		},

		toggleCollapseKeyword() {
			this.openCollapseFilterKey = !this.openCollapseFilterKey
		},

		handleFilterKeyword(val) {
			this.setParamSearchLesson({ ...this.paramSearchLessons, keyword: val });
		},

		handleSearchByKeyword: debounce(function (e) {
			this.setParamSearchLesson({ ...this.paramSearchLessons, keyword: e.target.value });
		}, 300),

		handleFilterSort() {
			this.setParamSearchLesson({ ...this.paramSearchLessons, direction: this.paramSearchLessons.direction === 'desc' ? 'asc' : 'desc', pageIndex: 1 })
		}
	}
};
</script>

<style lang="scss" scoped>
@import "./../../../assets/scss/variables";
@import "./../../../assets/scss/mixins";
@import "./../../../assets/scss/general";

.height-100 {
	height: 100%;
}

span.mn {
	font-size: 20px;
	position: absolute !important;
	right: 0;
}

.collapse-subject {
	.subject-list {
		padding-left: 18px;
		margin-top: 6px;
	}
}

.ss-data {
	padding: 25px 0 70px;
}

.ss-banner--not-bg {
	padding: 40px 0 10px;

	@media screen and (max-width: 991px) {
		padding: 20px 0 10px;
	}
}

.library {

	&__data {
		width: 100%;

		&__head {
			border-bottom: 1px solid $color_border_main;
			margin-top: 30px;

			.nav-tabs {
				border: 0;
			}

			.btn-collapse {
				line-height: 1.3;
				letter-spacing: 0.03em;

				i {

					&:not(.margin-0) {
						margin-left: 6px;
					}
				}
			}

			&__collapse {
				>* {
					&:not(:last-child) {
						margin-right: 15px;
					}
				}
			}
		}

		&__filter {
			padding: 20px 0 10px;

			&__keyword {
				width: 28%;

				input {
					padding: 5px 30px 5px 15px !important;
					@extend .full-width;
				}

				i {
					color: $primary_color;
				}
			}
		}
	}

	&__tabs {
		&__content {
			padding: 35px 0 20px;
		}
	}

	@media screen and (max-width: 991px) {
		&__wrap {
			display: block;
		}

		&__sidebar,
		&__data {
			width: 100%;
		}

		&__sidebar {
			margin-bottom: 30px;
		}
	}

	@media screen and (max-width: 600px) {
		&__data {
			&__head {
				display: block;

				&__collapse {
					padding: 8px 0;
				}
			}

			&__filter {
				&__keyword {
					width: 100%;
				}
			}
		}
	}

	// .ss-banner--not-bg {
	//   padding-top: 15px;
	// }

	.ss-data {
		padding-top: 0;
	}
}

#collapse_filter {
	border-bottom: 1px solid $color_border_main;
}

.nav-tabs {
	border-bottom: 0 !important;
}

.electronic-lecture {
	&__head {
		padding-bottom: 7px;
		border-bottom: 1px solid #d0d5d8;
		margin: 32px 0 24px 0;
	}
}

@media screen and (max-width: 1300px) {
	.library__data__head__collapse {
		display: flex;

		.filter-btn {
			width: 100px;
		}
	}
}
</style>